import * as React from 'react'
import { CustomFlagIconFactory } from 'react-flag-icon-css'
import { codes } from '../../assets/flags';

// // Using 'react-css-modules'? Use this:
// const optionsCssModules = { customCodes: codes, themeStyles: styles }
// const FlagIconCssModules = CustomFlagIconFactory(React, optionsCssModules)

// Using global CSS? Use this instead:
const options = { useCssModules: false, customCodes: codes }
const FlagIcon = CustomFlagIconFactory(React, options)

export default FlagIcon